/* global debounce */

// *******************************************************************************
// 2.0 - Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffert = document.documentElement.scrollTop || document.body.scrollTop;

  document.body.classList.toggle('is-scrolled', topOffert > 100);
}

// Debounce the function to prevent multiple executions on scroll event
const debounceScroll = debounce(() => {
  addScrollingClass();
});

window.addEventListener('scroll', debounceScroll);
